import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const Header = () => {
    const navigate = useNavigate();
    const [showDropdown, setShowDropdown] = useState(false);
    const [userData, setUserData] = useState({ loggedInUserName: '' });
    const dropdownRef = useRef(null);

    // Get user data from localStorage on load
    useEffect(() => {
        const name = localStorage.getItem("loggedInUserName");
        console.log("Loaded username:", name);
        if (name) {
            setUserData({ loggedInUserName: name });
        }
    }, []);


    // Close dropdown on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <header
            className="has-text-black p-5"
            style={{
                height: "64px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                backgroundColor: "#fff",
                zIndex: 1000,
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
            }}
        >
            {/* Logo */}
            <div>
                <img
                    src="../logo192.png"
                    alt="Logo"
                    style={{ height: "61px", width: "65px", objectFit: "contain" }}
                />
            </div>

            {/* Center Navigation Tabs */}
            <div style={{ display: "flex", gap: "2rem", justifyContent: "center", flex: 1 }}>

            </div>

            {/* Right: User Info + Profile */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }} ref={dropdownRef}>
                {/* User name and role/category */}
                <div style={{ textAlign: 'right' }}>
                    <div style={{ fontWeight: 'bold' }}>{userData.loggedInUserName || 'User'}</div>
                    {/* <div style={{ fontSize: '12px', color: '#666' }}>
                        {userData.role ? userData.role : userData.category || 'Admin'}
                    </div> */}
                </div>

                {/* Profile image */}
                <img
                    src="https://randomuser.me/api/portraits/women/44.jpg" // Replace with actual user image if available
                    alt="User"
                    style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        cursor: "pointer"
                    }}
                    onClick={() => setShowDropdown(!showDropdown)}
                />

                {/* Dropdown */}
                {showDropdown && (
                    <div
                        style={{
                            position: "absolute",
                            top: "50px",
                            right: 0,
                            backgroundColor: "#fff",
                            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                            borderRadius: "8px",
                            padding: "10px",
                            minWidth: "150px",
                            zIndex: 999,
                        }}
                    >
                        <div style={{ padding: "8px", cursor: "pointer" }}>Profile</div>
                        <div style={{ padding: "8px", cursor: "pointer" }}>Settings</div>
                        <hr style={{ margin: "5px 0" }} />
                        <div
                            style={{ padding: "8px", cursor: "pointer", color: "red" }}
                            onClick={() => {
                                localStorage.clear();
                                navigate('/review-login');
                            }}
                        >
                            Logout
                        </div>
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;